<template>
  <div>
    <v-text-field v-model="value.mch_id" label="微信支付商户号" class="required" />
    <v-text-field v-model="value.app_id" label="微信AppId" />
    <PasswordField v-model="value.apiv3_secret" label="微信支付ApiV3密钥" class="required" />
    <v-text-field v-model="value.mch_cert_id" label="商户证书序列号" class="required" />
    <v-textarea class="config-textarea required" v-model="value.mch_cert_private_key" label="商户证书私钥PEM文件内容" />
    <v-checkbox label="支持扫码支付" v-model="value.is_support_code" />
    <v-checkbox label="支持JSAPI支付" v-model="value.is_support_jsapi" />
    <v-checkbox label="支持APP支付" v-model="value.is_support_app" />
    <v-checkbox label="支持H5支付" v-model="value.is_support_h5" />
  </div>
</template>

<script>
import PasswordField from '@/components/PasswordField.vue'

export default {
  components: { PasswordField },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="less" scoped>
.config-textarea /deep/ textarea {
  font-size: 14px;
  font-family: monospace;
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>
